import * as React from 'react';

export interface IAccountSupportSettingsProps {
}

export function AccountSupportSettings(props: IAccountSupportSettingsProps) {

    const faqData = [
        {
            id: 1,
            question: 'General help',
            answere: 'Visit our help center to learn how to get started with buying, selling, and creating.',
        },
        {
            id: 2,
            question: 'Contact UNC Support',
            answere: 'Once the Public Sale is completed, you will be able to see your Mystery Wolf on your OpenSea profile by simply connecting your wallet to the OpenSea website. The hatch will happen 2 days after the public sale.',
        },
        {
            id: 3,
            question: 'Help with a compromised account',
            answere: 'The whitelist Private Sale will start on December 20th at 6 PM UTC time and the Public Sale will be in the …',
        },
        {
            id: 4,
            question: 'Cancel all Ethereum listings and offers',
            answere: 'CWC NFTs will be your pass for the membership in the most Exclusive Club in the Crypto space. You will enjoy privileges, private events, be a share owner of a CWC land in metaverse space (another spoiler), private parties, crypto project and get to know all the others owners in Members group or in the live events. Furthermore, if you’ll be lucky enough, you will get the chance to go to the moon with other business rich men that can afford a 150k ticket to get the one life time experience and see the earth from the space!',
        },
    ]


    return (
        <div className="text-left mt-8 account_support_main_box">
            <h1 className="text-xl sm:text-2xl xl:text-3xl font-extrabold text-cusBlack dark:text-white">Account Support</h1>
            <p className="text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2">If you need help related to your account, we can help you.</p>


            <div className="md:w-8/12 lg:w-6/12 xl:w-5/12">
                {faqData.map(faq =>
                    <div key={faq.id} className="tab lightBlueBg rounded-xl w-full text-left mt-5 relative">
                        <input
                            className="absolute opacity-0"
                            id={`tab-multi-${faq.id}`}
                            type="checkbox" name="tabs" />
                        <label
                            className="block p-4 lg:p-5 leading-normal cursor-pointer"
                            htmlFor={`tab-multi-${faq.id}`}>
                            <p className="text-cusBlack dark:text-white xs:text-xs sm:text-sm lg:text-base xs:pr-14 ">{faq.question}</p>
                        </label>
                        <label htmlFor={`tab-multi-${faq.id}`}
                            className="absolute right-5 top-6 downArrow">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18.657" height="11.328" viewBox="0 0 18.657 11.328">
                                <path id="Path_1167" data-name="Path 1167" d="M3208,826l6.5,6.5,6.5-6.5" transform="translate(-3205.171 -823.172)" fill="none" stroke="#6f6dab" strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} />
                            </svg>
                        </label>

                        <div className="tab-content overflow-hidden leading-normal">
                            <p className="p-5 xs:text-xxs xsm:text-xs lg:text-base text-l-LightBlack dark:text-cusBlueWhite">{faq.answere}</p>
                        </div>
                    </div>
                )
                }
            </div>


        </div>
    );
}
